import { environment } from '@env/environment';
import { OutlawCommunityConfig } from '@outlaw/community';
import { FeatureState } from '@outlaw/core';
import { projectConfig } from './project.config';

export const outlawCommunityConfig: OutlawCommunityConfig = {
  userId: environment.ownerId,
  groupId: environment.groupId,
  title: 'Dhar Mann',
  name: 'dhar-mann',
  gptAppId: 'dhar-mann',
  menu: [],
  partnerServices: {
    argoUrl: environment.argoApiUrl,
    paymentServiceUrl: environment.paymentServiceUrl,
  },
  featureFlags: {
    paywall: FeatureState.enabled,
    newPlaylist: FeatureState.disabled,
    communityInApp: FeatureState.disabled,
    comments: FeatureState.enabled,
    paidPosts: FeatureState.enabled,
    openProfileInNewWindow: FeatureState.enabled,
    showRecommendationMessage: FeatureState.enabled,
    showProfileLinksInRecommendedByDialog:
      projectConfig.profileType === 'group'
        ? FeatureState.enabled
        : FeatureState.disabled,
    showWidgets: environment?.featureFlags?.showWidgets || FeatureState.enabled,
  },
  links: {
    creatorLink: environment.creatorUrl,
  },
  externalApi: {
    argo: environment.argoApiUrl,
    brandon: '',
  },
  baseUrl: environment.communityApiUrl,
};
